import { render } from "./WidgetButtonAnimationMode.vue?vue&type=template&id=504e748b&scoped=true"
import script from "./WidgetButtonAnimationMode.vue?vue&type=script&lang=js"
export * from "./WidgetButtonAnimationMode.vue?vue&type=script&lang=js"

import "./WidgetButtonAnimationMode.vue?vue&type=style&index=0&id=504e748b&lang=scss&scoped=true"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504e748b"]])

export default __exports__